$(document).ready(function () {

    const wrapper = document.querySelector(".mobile-nav-menu-wrapper");
    let lastScroll = 0;

    if (!wrapper) return;

    /* ---------------------------------
       SUBMENU OPEN (Freeze → Reset → Unfreeze)
    ----------------------------------*/
    $(".m-menu__checkbox").change(function () {

        wrapper.style.scrollBehavior = "auto";
        
        if (this.checked) {
            // Save current scroll
            lastScroll = wrapper.scrollTop;

            // Instantly freeze
            wrapper.style.overflow = "hidden";

            // Instantly move to 0 (no animation possible)
            wrapper.scrollTop = 0;

            // Unfreeze next frame
            requestAnimationFrame(() => {
                wrapper.style.overflow = "";
            });
        }
    });

    /* ---------------------------------
       SUBMENU CLOSE (Freeze → Restore → Unfreeze)
    ----------------------------------*/
    $(".m-menu__toggle").click(function () {

        // Freeze before scroll change
        wrapper.style.overflow = "hidden";

        // Restore scroll instantly (still frozen, so invisible)
        wrapper.scrollTop = lastScroll;

        // Unfreeze next frame
        requestAnimationFrame(() => {
            wrapper.style.overflow = "";
        });
    });

});




document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".mds-banner-new-media video");

  videos.forEach(video => {
    // Force autoplay setup
    video.muted = true;          // required for autoplay
    video.playsInline = true;    // for iOS Safari
    video.setAttribute("autoplay", "true");
    video.setAttribute("muted", "true");
    video.setAttribute("playsinline", "true");

    // Try autoplay
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log("Autoplay working ✅");
        })
        .catch(() => {
          console.log("Autoplay blocked — forcing play on interaction 🖱️");
          const resumeAutoplay = () => {
            video.play();
            document.body.removeEventListener("click", resumeAutoplay);
            document.body.removeEventListener("touchstart", resumeAutoplay);
          };
          // wait for user interaction only if blocked
          document.body.addEventListener("click", resumeAutoplay);
          document.body.addEventListener("touchstart", resumeAutoplay);
        });
    }
  });
});


// Menu Icon Custom
$(document).ready(function () {
  // When menu button is clicked
  $('.menu-btn').click(function () {
    const $this = $(this);
    const body = $('body');
    const html = $('html');

    // ✅ FORCE CLOSE SEARCHSPRING
    body.removeClass('ss__autocomplete--active');

    // If Searchspring injected overlay container
    $('.ss__autocomplete').removeClass('ss__autocomplete--active');

    // Close custom modal search
    $('.modal-search')
        .removeClass('expand-searchnew show')
        .hide();    

    // Toggle active/open states
    $this.toggleClass('open isactive');

    // Toggle mobile nav open state
    body.toggleClass('mobile_nav_opened');

    // Add "no scroll" lock only when menu is opened at top
    if (body.hasClass('mobile_nav_opened') && $(window).scrollTop() === 0) {
      body.addClass('mobile_nav_bar_top_no_scroll');
    } else {
      body.removeClass('mobile_nav_bar_top_no_scroll');
    }

    // Close any active search modal if open
    // $('.modal-search').removeClass('expand-searchnew show').hide('slow').siblings().show('slow');
  });

  // When clicking on overlay — close menu
  $('.mobile_menu_overlay').click(function () {
    const body = $('body');
    const html = $('html');

    // Handle sticky header when scrolled
    if (window.scrollY > 0) {
      body.addClass('header_sticky');
    } else {
      body.removeClass('header_sticky');
    }

    // Reset states
    body.removeClass('mobile_nav_opened mobile_nav_bar_top_no_scroll');
    html.removeClass('overflow_hidden');
    html.removeClass('menu_drawer_open');
    body.css({ overflow: '', height: '' });
    $('.menu-btn').removeClass('open isactive');
  });

  // When cross button is clicked (optional separate close icon)
  $('.mobile-nav-trigger_cross').click(function () {
    $('body').removeClass('mobile_nav_opened mobile_nav_bar_top_no_scroll');
    $('html').removeClass('overflow_hidden');
    $('html').removeClass('menu_drawer_open');
    $('body').css({ overflow: '', height: '' });
    $('.menu-btn').removeClass('open isactive');
  });
});






(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const menuRoot = document.querySelector(".mobile_main_nav_list");
    const menuBtn = document.querySelector(".menu-btn");
    const menuDrawer = document.querySelector(".mobile_navigation_wrap");
    const html = document.documentElement;
    if (!menuRoot) return;

    function setActive(li) {
      const parentUl = li.closest("ul");
      if (!parentUl) return;

      const siblings = parentUl.querySelectorAll(":scope > li");
      siblings.forEach((sib) => {
        if (sib === li) {
          sib.classList.add("item_active");
          sib.classList.remove("item_disable");
        } else {
          sib.classList.remove("item_active");
          sib.classList.add("item_disable");
        }
      });
    }

    function clearStates() {
      menuRoot
        .querySelectorAll("li")
        .forEach((li) =>
          li.classList.remove("item_active", "item_disable")
        );
    }

    function isCheckboxChecked(li) {
      const checkbox = li.querySelector(":scope > .m-menu__checkbox");
      return checkbox && checkbox.checked;
    }

    // ---------------- HOVER ----------------
    menuRoot.addEventListener("mouseover", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;

      const from = e.relatedTarget;
      if (from && li.contains(from)) return;

      // ❌ Parent <li> with open submenu must NOT get active
      if (isCheckboxChecked(li)) {
        li.classList.remove("item_active", "item_disable");
        return;
      }

      setActive(li);
    });

    // ---------------- REMOVE ACTIVE WHEN MOUSE LEAVES LI ----------------
    menuRoot.addEventListener("mouseout", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;

      const to = e.relatedTarget;
      if (to && li.contains(to)) return;

      li.classList.remove("item_active", "item_disable");

      const parentUl = li.closest("ul");
      if (parentUl) {
        parentUl.querySelectorAll(":scope > li").forEach((sib) =>
          sib.classList.remove("item_active", "item_disable")
        );
      }
    });

    // ---------------- CLICK ----------------
    menuRoot.addEventListener("click", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;
      e.stopPropagation();

      // ❌ If parent submenu is open — never highlight parent
      if (isCheckboxChecked(li)) {
        li.classList.remove("item_active", "item_disable");
        return;
      }

      const parentUl = li.closest("ul");
      const siblings = parentUl.querySelectorAll(":scope > li");

      if (li.classList.contains("item_active")) {
        siblings.forEach((sib) =>
          sib.classList.remove("item_active", "item_disable")
        );
      } else {
        setActive(li);
      }

      // document.documentElement.classList.remove("menu_drawer_open");
    });

    // ---------------- OUTSIDE CLICK ----------------
    document.addEventListener("click", function (e) {
    if (
        html.classList.contains("menu_drawer_open") &&
        menuDrawer &&
        !menuDrawer.contains(e.target) &&
        menuBtn &&
        !menuBtn.contains(e.target)
    ) {
        html.classList.remove("menu_drawer_open");
        clearStates();
    }
    });

    // ---------------- MENU BUTTON ----------------
    if (menuBtn) {
    menuBtn.addEventListener("click", function (e) {
        e.stopPropagation();

        if (html.classList.contains("menu_drawer_open")) {
        html.classList.remove("menu_drawer_open");
        } else {
        html.classList.add("menu_drawer_open");
        }
    });
    }

    // ---------------- CLOSE MENU ON OUTSIDE ----------------
    // document.addEventListener("click", function (e) {
    //   if (
    //     !e.target.closest(".menu-btn") &&
    //     !e.target.closest(".mobile_main_nav_list")
    //   ) {
    //     document.documentElement.classList.remove("menu_drawer_open");
    //   }
    // });
  }
})();







// Animaton End **************************
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    const bagsSwiper = new Swiper(".bags-slider", {
      slidesPerView: 5,
      slidesPerGroup: 5,
       spaceBetween: 24,
      loop: false, // ✅ no glitch, consistent scrolling
      speed: 600,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: { slidesPerView: 3, slidesPerGroup: 3 , spaceBetween: 12 },
        640: { slidesPerView: 3, slidesPerGroup: 3 , spaceBetween: 12 },
        1024: { slidesPerView: 5, slidesPerGroup: 5 ,  spaceBetween: 24 },
      },
    });
  } else {
    console.error("Swiper is not loaded. Please include Swiper JS before this script.");
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   let els = document.querySelectorAll(".main_product_warp");
//   els.forEach(el => el.classList.add("active")); // sabhi me add karo

//   setTimeout(() => {
//     els.forEach(el => el.classList.remove("active")); // 100ms baad sabhi se remove
//   }, 100);
// });

document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll(".product_image_list_3");

  images.forEach(img => {
    const wrapper = img.closest(".main_product_warp");
    const placeholder = wrapper ? wrapper.querySelector(".image-placeholder") : null;

    // Function to show image + hide loader
    const showImage = () => {
      img.style.opacity = "1";
      if (placeholder) placeholder.style.display = "none";
    };

    // If image already loaded (cached), handle immediately
    if (img.complete) {
      showImage();
    } else {
      // Normal case: wait for load or error
      img.addEventListener("load", showImage);
      img.addEventListener("error", showImage); // hide loader even if broken
    }
  });
});
/* Swiper Slider packaging */
document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".pdp_packaging_block", {
        loop: true,
        pagination: {
            el: ".pdp_packaging-pagination",
            clickable: true,
        },
    });
});
/* Swiper Slider packaging End */
// announcement Bar
document.addEventListener("DOMContentLoaded", () => {
    const announcementBarContainer = document.querySelector(".mds-animated-banner__slider-container");
    const announcementSlides = announcementBarContainer.querySelectorAll(".mds-animated-banner__content");
    let activeSlideIndex = 0;

    function updateSlideClasses() {
        // Remove '-visible' and '-next' classes from all slides
        announcementSlides.forEach((slide) => slide.classList.remove("-visible", "-next"));

        // Add '-visible' to the active slide
        announcementSlides[activeSlideIndex].classList.add("-visible");

        // Calculate and add '-next' to the upcoming slide
        const nextSlideIndex = (activeSlideIndex + 1) % announcementSlides.length;
        announcementSlides[nextSlideIndex].classList.add("-next");
    }

    function showNextAnnouncementSlide() {
        // Update the active slide index
        activeSlideIndex = (activeSlideIndex + 1) % announcementSlides.length;

        // Update slide classes
        updateSlideClasses();
    }

    // Initial setup
    updateSlideClasses();

    // Rotate slides every 4 seconds
    setInterval(showNextAnnouncementSlide, 4000);
});

// For Filter Sticky
document.addEventListener("scroll", () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (scrollTop >= 200) {
        document.body.classList.add("FilterStickyActive");
    } else {
        document.body.classList.remove("FilterStickyActive");
    }
});

// Giveaway Home SLider
$(document).ready(function () {
    // Feature slider pdp
    if ($(".feature_slider_row")) {
        $(".feature_slider_row").slick({
            infinite: true,
            arrows: false,
            dots: false,
            autoplay: false,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }
    //ticking machine
    var percentTime;
    var tick;
    var time = 1;
    var progressBarIndex = 0;
    if ($(".progressBarContainer .progressBar")) {
        $(".progressBarContainer .progressBar").each(function (index) {
            var progress = "<div class='inProgress inProgress" + index + "'></div>";
            $(this).html(progress);
        });
    }
    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if ($('.feature_slider_row .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden") === "true") {
            progressBarIndex = $('.feature_slider_row .slick-track div[aria-hidden="false"]').data("slickIndex");
            startProgressbar();
        } else {
            percentTime += 1 / (time + 5);
            $(".inProgress" + progressBarIndex).css({
                width: percentTime + "%",
            });
            if (percentTime >= 100) {
                $(".single-item").slick("slickNext");
                progressBarIndex++;
                if (progressBarIndex > 2) {
                    progressBarIndex = 0;
                }
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $(".inProgress").css({
            width: 0 + "%",
        });
        clearInterval(tick);
    }
    startProgressbar();
    // End ticking machine
    if ($(".progressBarContainer div")) {
        $(".progressBarContainer div").click(function () {
            clearInterval(tick);
            var goToThisIndex = $(this).find("span").data("slickIndex");
            $(".single-item").slick("slickGoTo", goToThisIndex, false);
            startProgressbar();
        });
    }
    if ($(".feature_slider_row")) {
        $(".feature_slider_row").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            $(".current-slide").text((nextSlide + 1).toString().padStart(2, "0")); // Update current slide number
        });
    }

    $(".next-slide").click(function () {
        $(".feature_slider_row").slick("slickNext");
    });

    // Previous slide button click event
    $(".prev-slide").click(function () {
        $(".feature_slider_row").slick("slickPrev");
    });
    // Feature slider pdp end

    if ($(".giveaway-blog-row")) {
        $(".giveaway-blog-row").slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick",
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }
});

// Play and Pause flickity Slider
// For Desktop
document.addEventListener("DOMContentLoaded", function () {
    var splide = new Splide("#splide", {
        type: "loop",
        drag: "free",
        focus: "center",
        arrows: false,
        perPage: 5,
        autoScroll: {
            speed: 0.5,
            pauseOnHover: false,
            pauseOnFocus: false,
        },
        keyboard: true,
        rewind: true,
        // Responsive breakpoints
        breakpoints: {
            1500: {
                perPage: 4,
            },
            991: {
                perPage: 3,
            },
            580: {
                perPage: 2,
            },
            400: {
                perPage: 2,
            },
        },
    }).mount(window.splide.Extensions);
        setTimeout(() => {
        splide.Components.AutoScroll.pause();
        splide.Components.AutoScroll.play();
    }, 100);

    var button = document.querySelector("#splide .splide__play-pause");

    if (button) {
        var pausedClass = "is-paused";

        // Remove the paused class and change the label to "Pause".
        splide.on("autoplay:play", function () {
            button.classList.remove(pausedClass);
            button.textContent = "Pause";
            button.setAttribute("aria-label", "Pause Autoplay");
        });

        // Add the paused class and change the label to "Play".
        splide.on("autoplay:pause", function () {
            button.classList.add(pausedClass);
            button.textContent = "Play";
            button.setAttribute("aria-label", "Start Autoplay");
        });

        // Toggle play/pause when the button is clicked.
        splide.on(
            "click",
            function () {
                var flag = 99;
                var Autoplay = splide.Components.Autoplay;

                if (button.classList.contains(pausedClass)) {
                    Autoplay.play(flag);
                } else {
                    Autoplay.pause(flag);
                }
            },
            button
        );
    }
    function updateSlideCount() {
        var activeSlideIndex = document.querySelector("#splide .splide__pagination__page.is-active").getAttribute("aria-label").replace(/\D/g, "");
        var totalSlides = document.querySelectorAll("#splide .splide__pagination__page").length;
        if (document.querySelector(".news__counter")) {
            document.querySelector(".news__counter").innerText = `${activeSlideIndex}/${totalSlides}`;
        }
    }
    setInterval(updateSlideCount, 300);

    // $("body").on("click", function () {
    //     // Remove class "pause-active" from pauseBtn
    //     console.log("helllo");
    //     var button = document.querySelector("#splide #splide-track");
    //     var attr = button.getAttribute("aria-live");
    //     var pauseBtn = document.querySelector("#splide .splide__optional-button-container");
    //     if (attr == "polite") {
    //         pauseBtn.classList.add("pause-active");
    //     } else {
    //         pauseBtn.classList.remove("pause-active");
    //     }
    // });
});

// Start size chart JS
document.addEventListener("DOMContentLoaded", function () {
    let scrollY = 0;

    var size_guide_button = document.querySelector(".size_cart_text");
    var size_guide_modal = document.querySelector(".mds_chart_modal");
    var size_chart_mask = document.querySelector(".pdp-size-chart_mask");
    var size_guide_close_button = document.querySelector(".mds_chart_modal-btn-close");

    if (size_guide_button) {
        size_guide_button.addEventListener("click", function () {
            size_guide_modal.classList.add("chart_active");
            size_chart_mask.classList.add("mask_active");

            // Scroll lock for iOS Safari
            scrollY = window.scrollY || window.pageYOffset;
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = "0";
            document.body.style.right = "0";

            document.body.classList.add("mds_chart_active");
            document.documentElement.classList.add("no-scroll");
        });
    }

    if (size_guide_close_button) {
        size_guide_close_button.addEventListener("click", function () {
            size_guide_modal.classList.remove("chart_active");
            size_chart_mask.classList.remove("mask_active");

            // Scroll unlock
            document.body.classList.remove("mds_chart_active");
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.documentElement.classList.remove("no-scroll");

            window.scrollTo(0, scrollY);
        });
    }

    var size_chart_tabs = document.querySelectorAll(".tab-pane.mds_tab-pane");
    var size_chart_size_chart_tabs_btns = document.querySelectorAll("span.pdp-size-chart__tab-selected-links.tab-btn");

    if (size_chart_size_chart_tabs_btns) {
        size_chart_size_chart_tabs_btns.forEach(function (btn, index) {
            btn.addEventListener("click", function () {
                // Remove active class from all size_chart_tabs and buttons
                size_chart_tabs.forEach(function (tab) {
                    tab.classList.remove("active");
                });
                size_chart_size_chart_tabs_btns.forEach(function (tabBtn) {
                    tabBtn.classList.remove("active");
                });

                // Add active class to the clicked button and tab
                btn.classList.add("active");
                size_chart_tabs[index].classList.add("active");
            });
        });
    }

    if (document.querySelectorAll(".pdp-size-chart__size-buttons-list li")) {
        document.querySelectorAll(".pdp-size-chart__size-buttons-list li").forEach((item) => {
            item.addEventListener("click", (event) => {
                if (item.classList.contains("disabled")) return;

                document.querySelectorAll(".pdp-size-chart__size-buttons-list li").forEach((li) => {
                    document.getElementById("inch-button").classList.remove("active");
                    li.classList.remove("active");
                    convertModelMeasurements();
                });

                document.getElementById("cm-button").classList.add("active");
                item.classList.add("active");
            });
        });
    }

    if (document.getElementById("inch-button")) {
        document.getElementById("inch-button").addEventListener("click", function () {
            if (!this.classList.contains("active")) {
                document.getElementById("cm-button").classList.remove("active");
                this.classList.add("active");
                convertMeasurements("inch");
                // convertModelMeasurements('inch');
            }
        });
    }

    if (document.getElementById("cm-button")) {
        document.getElementById("cm-button").addEventListener("click", function () {
            if (!this.classList.contains("active")) {
                document.getElementById("inch-button").classList.remove("active");
                this.classList.add("active");
                convertMeasurements("cm");
                // convertModelMeasurements('cm');
            }
        });
    }

    function convertModelMeasurements() {
        var element = document.querySelector(".pdp-size-chart__model-measurements.mds_chart_col16.model_measurements");

        var descriptionElement = document.querySelector(".pdp-size-chart__model-description.mds_chart_col16");
        var newDescriptionContent = descriptionElement.getAttribute("data-heading");

        descriptionElement.innerHTML = newDescriptionContent;
    }

    function convertMeasurements(unit) {
        const measurementElements = document.querySelectorAll(".measurement");
        const measurementElementsinfeet = document.querySelector(".measurementinfeet");
        const measurementElementsinfeet2 = document.querySelector(".measurementinfeet2");
        const feetAndInches = "6ft ";
        const feetAndInches2 = '5ft 9"';
        const feet = parseInt(feetAndInches);
        const feet2 = parseInt(feetAndInches2);
        const inches2 = parseFloat(feetAndInches2.substring(feetAndInches2.indexOf(" ") + 1, feetAndInches2.indexOf('"')));
        const inches = parseFloat(feetAndInches.substring(feetAndInches.indexOf(" ") + 1, feetAndInches.indexOf('"')));
        measurementElements.forEach((element) => {
            const value = parseFloat(element.textContent);
            if (unit === "inch") {
                element.textContent = (value / 2.54).toFixed(2) + '"';
                if (measurementElementsinfeet) {
                    measurementElementsinfeet.textContent = feet + "ft ";
                }
                if (measurementElementsinfeet2) {
                    measurementElementsinfeet2.textContent = feet2 + "ft " + inches2 + '"';
                }
            } else if (unit === "cm") {
                element.textContent = (value * 2.54).toFixed(1) + " cm";
                const totalInches2 = feet2 * 12 + inches2;
                const totalInches = feet * 12 + inches;
                if (measurementElementsinfeet) {
                    measurementElementsinfeet.textContent = "185cm";
                }
                if (measurementElementsinfeet2) {
                    measurementElementsinfeet2.textContent = "176cm";
                }
            }
        });
    }

    if (document.getElementById("size-chart-measurement-input")) {
        document.getElementById("size-chart-measurement-input").addEventListener("change", function () {
            var selectedValue = this.value;
            var measurementsTab = document.querySelector('.tab-pane.mds_tab-pane[data-tab="measurements"]');
            var conversionTab = document.querySelector('.tab-pane.mds_tab-pane[data-tab="conversion"]');

            if (selectedValue === "measurements") {
                measurementsTab.classList.add("active");
                conversionTab.classList.remove("active");
            } else if (selectedValue === "conversion") {
                conversionTab.classList.add("active");
                measurementsTab.classList.remove("active");
            }
        });
    }
});
// End size chart JS

// Fancybox Config
// Fancybox Config
$('[data-fancybox="gallery"]').fancybox({
    buttons: ["close"],
    loop: false,
    clickContent: false,
    btnTpl: {
        smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>',
        close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
            '<path d="M13.4115 15.2153L8 9.8038L2.58847 15.2153L0.784624 13.4115L6.19616 7.99995L0.784625 2.58842L2.58847 0.784578L8 6.19611L13.4115 0.784578L15.2154 2.58842L9.80384 7.99995L15.2154 13.4115L13.4115 15.2153Z" fill="black"/>' +
            "</svg>" +
            "</button>",
        arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">' +
            '<path d="M6.25247 11.8182L7.63635 10.4509L3.1412 5.99999L7.63635 1.54908L6.25247 0.181811L0.363625 5.99999L6.25247 11.8182Z" fill="black"/>' +
            "</svg>" +
            "</button>",

        arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">' +
            '<path d="M1.74753 0.181824L0.363647 1.5491L4.8588 6.00001L0.363647 10.4509L1.74753 11.8182L7.63637 6.00001L1.74753 0.181824Z" fill="black"/>' +
            "</svg>" +
            "</button>",
    },
});
// Product page scroll slider
// Get the product slider container
var productSliderContainer = document.querySelector(".product__media-list");

// Get the track element
var trackElement = document.querySelector(".mds-mini-slider__track");

// Get the knob element
var knobElement = document.querySelector(".mds-mini-slider__knob");

// Function to update knob position
function updateKnobPosition() {
    // Calculate the translation in pixels based on the width of the product slider container
    var containerWidth = productSliderContainer.offsetWidth;
    var knobWidth = knobElement.offsetWidth;
    var maxTranslation = containerWidth - knobWidth;
    var trackWidth = trackElement.offsetWidth;
    var translation = (productSliderContainer.scrollLeft / (productSliderContainer.scrollWidth - productSliderContainer.clientWidth)) * maxTranslation;

    // Constrain translation to stay within the bounds of the track
    const constrainedTranslation = Math.min(Math.max(0, translation), trackWidth - knobWidth);

    // Update the knob position
    knobElement.style.transform = `translateX(${constrainedTranslation}px)`;
}

// Call the function to update knob position initially
if (productSliderContainer) {
    updateKnobPosition();

    // Add event listener for scroll event
    productSliderContainer.addEventListener("scroll", function () {
        updateKnobPosition();
    });
}
